import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Tailwind-aware className combiner. Merges conflicting utilities so
 * `cn('p-2', 'p-4')` resolves to `p-4`, never both. Used by every
 * primitive that accepts a `className` prop.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
